import { useContext, useMemo, FC } from 'react'
import { hicContext } from 'src/app/hooks/context/context'
import { useGrant } from './grant-hooks'
import { IfGrantedProps } from './if-granted'

export const OperationIfGranted: FC<IfGrantedProps & { childrenWithoutPermissions?: React.ReactNode }> = (props) => {
  const { context } = useContext(hicContext)
  const { children, childrenWithoutPermissions } = props

  const { isGranted } = useGrant()

  const isGrantedCheck = useMemo(() => {
    return isGranted({ modules: props.modules, features: props.features, permissions: props.permissions })
  }, [props, context.loading])

  if (context.loading) {
    return <>{childrenWithoutPermissions}</>
  } else {
    if (isGrantedCheck) {
      return <>{children}</>
    } else {
      return <>{childrenWithoutPermissions}</>
    }
  }
}
